import { useEffect, useRef } from "react";
import { Event, EventType } from "../../libs/data/event";
import { RegistrationSteps } from "../../libs/registration/registration-steps";
import { useRegistration } from "../../libs/registration/registration.hook";
import { BackButton } from "../form/styles/back-button";
import { CtaButton } from "../form/styles/cta-button";
import { LoadingComp } from "../loading/loading.comp";

let registered = false;

export const PaymentComp = (props: {
  event?: Event;
  setStep: (step: RegistrationSteps) => void;
}) => {
  const { processing, registrationInfo, completeRegistration } =
    useRegistration();
  const numberOfStudents = Object.values(
    registrationInfo?.students || []
  ).reduce((acc: number, student: any) => {
    if (student.isParticipating) return acc + 1;
    return acc;
  }, 0);
  const isCamp = props.event?.type === EventType.Camp;

  useEffect(() => {
    if (!registered) {
      registered = true;
      completeRegistration();
    }
  }, []);

  const onClick = async () => {
    // localStorage.setItem("payInit", "true");
  };

  const onBack = () => {
    props.setStep(RegistrationSteps.TermsAndConditions);
  };

  const withFood = isCamp && registrationInfo.foodOption === "yes";

  return (
    <div>
      <BackButton onClick={onBack}>Back</BackButton>
      <a
        href={
          numberOfStudents === 4
            ? withFood
              ? props.event?.paymentFood4
              : props.event?.payment4
            : numberOfStudents === 3
            ? withFood
              ? props.event?.paymentFood3
              : props.event?.payment3
            : numberOfStudents === 2
            ? withFood
              ? props.event?.paymentFood2
              : props.event?.payment2
            : withFood
            ? props.event?.paymentFood
            : props.event?.payment
        }
      >
        <CtaButton onClick={onClick}>Proceed to payment</CtaButton>
      </a>
      {processing && <LoadingComp />}
    </div>
  );
};
